/**
 * 
 * @param {string} d 
 * @returns {string} Date in datestring format
 */
export const formatDate = (d) => {
    if (!d) return null;
    const date = new Date(d);
    return date.toDateString();
}